import { IntlShape } from 'react-intl';
import messages from './messages.json';

const subscriptionsFaq = (intl: IntlShape) => ([
  {
    id: 'billing-payments',
    title: intl.formatMessage(messages['faq.billing-payments.title']),
    items: [
      {
        id: 'billing-payments-cost',
        question: intl.formatMessage(
          messages['faq.billing-payments-cost.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.billing-payments-cost.answer'],
        ),
      },
      {
        id: 'billing-payments-charge',
        question: intl.formatMessage(
          messages['faq.billing-payments-charge.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.billing-payments-charge.answer'],
        ),
      },
      {
        id: 'billing-payments-accept',
        question: intl.formatMessage(
          messages['faq.billing-payments-accept.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.billing-payments-accept.answer'],
        ),
      },
      {
        id: 'billing-payments-renew',
        question: intl.formatMessage(
          messages['faq.billing-payments-renew.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.billing-payments-renew.answer'],
        ),
      },
      {
        id: 'billing-payments-refund',
        question: intl.formatMessage(
          messages['faq.billing-payments-refund.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.billing-payments-refund.answer'],
        ),
      },
    ],
  },
  {
    id: 'subscription-management',
    title: intl.formatMessage(messages['faq.subscription-management.title']),
    items: [
      {
        id: 'subscription-management-cancel',
        question: intl.formatMessage(
          messages['faq.subscription-management-cancel.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.subscription-management-cancel.answer'],
        ),
      },
      {
        id: 'subscription-management-access',
        question: intl.formatMessage(
          messages['faq.subscription-management-access.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.subscription-management-access.answer'],
        ),
      },
    ],
  },
  {
    id: 'account-information',
    title: intl.formatMessage(messages['faq.account-information.title']),
    items: [
      {
        id: 'account-information-share',
        question: intl.formatMessage(
          messages['faq.account-information-share.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.account-information-share.answer'],
        ),
      },
    ],
  },
  {
    id: 'technical-support',
    title: intl.formatMessage(messages['faq.technical-support.title']),
    items: [
      {
        id: 'technical-support-email',
        question: intl.formatMessage(
          messages['faq.technical-support-email.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.technical-support-email.answer'],
        ),
      },
      {
        id: 'technical-support-phone',
        question: intl.formatMessage(
          messages['faq.technical-support-phone.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.technical-support-phone.answer'],
        ),
      },
      {
        id: 'technical-support-forum',
        question: intl.formatMessage(
          messages['faq.technical-support-forum.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.technical-support-forum.answer'],
        ),
      },
    ],
  },
  {
    id: 'privacy-security',
    title: intl.formatMessage(messages['faq.privacy-security.title']),
    items: [
      {
        id: 'privacy-security-payment',
        question: intl.formatMessage(
          messages['faq.privacy-security-payment.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.privacy-security-payment.answer'],
        ),
      },
      {
        id: 'privacy-security-personal',
        question: intl.formatMessage(
          messages['faq.privacy-security-personal.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.privacy-security-personal.answer'],
        ),
      },
    ],
  },
  {
    id: 'additional-questions',
    title: intl.formatMessage(messages['faq.additional-questions.title']),
    items: [
      {
        id: 'additional-questions-pause',
        question: intl.formatMessage(
          messages['faq.additional-questions-pause.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.additional-questions-pause.answer'],
        ),
      },
      {
        id: 'additional-questions-discounts',
        question: intl.formatMessage(
          messages['faq.additional-questions-discounts.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.additional-questions-discounts.answer'],
        ),
      },
      {
        id: 'additional-questions-payment-fails',
        question: intl.formatMessage(
          messages['faq.additional-questions-payment-fails.question'],
        ),
        answer: intl.formatMessage(
          messages['faq.additional-questions-payment-fails.answer'],
        ),
      },
    ],
  },
]);

export default subscriptionsFaq;
